import { Injectable } from '@angular/core';
import { Observable } from 'rxjs'
import { HttpService } from '@ui-components/services';
import { IReport, IResponse } from '@interfaces/index';

@Injectable({
  providedIn: 'root',
})
export class ReportService {

  constructor(
    private http_service: HttpService
  ) { }

  getReport(report_id: number): Observable<IResponse<IReport>> {
    return this.http_service.get('myassessment/report/' + report_id)
  }

  downloadReport(html: string): Observable<Blob> {
    return this.http_service.download('myassessment/report/download', {
      html: html
    })
  }
}
